import { useCallback } from 'react';
import { selectFallbackTranslation, selectTranslation } from '../../localizationSelector';
import { Translate } from '../../types';
import { supplant } from '../supplant';
import { useAppSelector } from '../../../../hooks';

export const useTranslation = () => {
  const translations = useAppSelector(selectTranslation);
  const fallbackTranslations = useAppSelector(selectFallbackTranslation);
  const keyWithTitle = useCallback((key: string) => `${key}.title`, []);
  const keyWithDescription = useCallback((key: string) => `${key}.description`, []);
  const keyWithCallout = useCallback((key: string) => `${key}.callout`, []);
  const translate = useCallback<Translate>(
    (key: string, values?: Record<string, string> | undefined) => {
      let translation = translations[key];
      if (!translation) {
        translation = fallbackTranslations[key];
      }
      if (values != null) {
        return supplant(translation, values) || key;
      } else {
        return translation || key;
      }
    },
    [translations, fallbackTranslations],
  );
  return { translate, keyWithTitle, keyWithDescription, keyWithCallout };
};
